import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'aza-rws-like-unlike',
    templateUrl: 'like-unlike.component.html',
    standalone: false
})
export class LikeUnlikeComponent {
    @Input() isLiked: boolean;
    @Input() disabled: boolean;

    @Output() liked = new EventEmitter<void>();
    @Output() unliked = new EventEmitter<void>();

    onLike(): void {
        if (this.disabled) {
            return;
        }
        this.liked.next();
    }

    onUnlike(): void {
        if (this.disabled) {
            return;
        }
        this.unliked.next();
    }
}
